"use strict";
(function () {

    var _ = require('lodash'),
        TweenMax = require('gsap'),
        EnterFrame = require('./util/enterframe'),
        Scene = require('./threejs/AbstractScene'),
        THREE = require('three'),
        Controls = require('./util/controls');

    Scene.worldPosition = function (obj) {

        var vector = new THREE.Vector3();
        obj.updateMatrixWorld();
        vector.setFromMatrixPosition(obj.matrixWorld);

        return vector;
    };
    Scene.toScreenPosition = function (obj, camera) {

        var vector = Scene.worldPosition(obj);

        vector.project(camera);

        var widthHalf = 0.5 * window.innerWidth;
        var heightHalf = 0.5 * window.innerHeight;

        vector.x = (vector.x * widthHalf) + widthHalf;
        vector.y = -(vector.y * heightHalf) + heightHalf;

        return {
            x: vector.x,
            y: vector.y
        };
    };

    var _currentX = 0,
        _currentY = 0,
        _limitX = 300,
        _limitY = 300,
        _lock = false,



        _getMapItemsByDistanceFromPoint = function (x, y) {
            var position,
                distance,
                x1, x2, y1, y2,
                tiles = [];

            _.each(this.mapItems, (tile, index) => {
                position = Scene.toScreenPosition(tile, this.map.scene.camera);
                x1 = x;
                y1 = y;
                x2 = position.x;
                y2 = position.y;
                distance = Math.sqrt((x2 -= x1) * x2 + (y2 -= y1) * y2);
                tile.velocity = distance / 20;
                tiles.push({
                    tile: tile,
                    position: position,
                    distance: distance
                });
            });

            tiles.sort(function (a, b) {
                if (a.distance > b.distance) {
                    return 1;
                }
                if (a.distance < b.distance) {
                    return -1;
                }
                return 0;
            });
            return tiles;
        },
        _onEnter = function (e) {

            _.each(this.mapItems, (tile, index) => {

                var p = isNaN(tile.velocity) ? 0 : tile.velocity;
                p = p / 50;
                p = p > 1 ? 1 : p < 0 ? 0 : p;
                //                p = 1 - p;
                p = (0.24 * p + 0.05);

                var tx = ((_currentX + tile.origin.x) - tile.position.x),
                    ty = ((-_currentY + tile.origin.y) - tile.position.y);

                //                var distance = Math.sqrt(Math.pow(tx, 2) + Math.pow(ty, 2)),
                //                    theta = Math.PI/6;

                tx *= p;
                ty *= p;



                tile.position.x += tx;
                tile.position.y += ty;

                //                console.log(p, _currentX, _currentY, tile.origin.x, tile.position.x);

            });
        },

        _onPan = function onPan(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            _.bind(_getMapItemsByDistanceFromPoint, this)(e.data.positionX, e.data.positionY);

            _lock = false;
            _currentX += e.data.x;
            _currentY += e.data.y;
            //            var theta = 30 * Math.PI/180;
            //            _currentX = Math.cos(theta) * _currentX;
            //            _currentY = Math.sin(theta) * _currentY;

            _currentX = _currentX > _limitX ? _limitX : _currentX < -_limitX ? -_limitX : _currentX;
            _currentY = _currentY > _limitY ? _limitY : _currentY < -_limitY ? -_limitY : _currentY;
        },

        _onPanStart = function (e) {
            e.preventDefault();
        },

        _onPanEnd = function (e) {
            e.preventDefault();
            _.each(this.mapItems, (tile) => {
                TweenMax.to(tile, 1, {
                    velocity: 1,
                    ease: Quint.easeOut
                });
            });
        };

    var PanControls = function (map) {
        this.map = map;
        this.mapItems = map.items;
        this.init();
    };
    PanControls.prototype = {
        init: function () {
            this.controls = new Controls();
            this.controls.addEventListener('pan', _.bind(_onPan, this));
            this.controls.addEventListener('pan-start', _.bind(_onPanStart, this));
            this.controls.addEventListener('pan-end', _.bind(_onPanEnd, this));
            this.map.scene.addEventListener(EnterFrame.RENDER, _.bind(_onEnter, this));
        },
        enable: function () {
            this.controls.enable();
        },
        disable: function () {
            this.controls.disable();
        }
    };

    window.onresize = function () {
        _limitX = window.innerWidth / 6;
        _limitY = window.innerHeight / 2;
    };

    module.exports = PanControls;

}());


/** WEBPACK FOOTER **
 ** ./holiday-map/pan-controls.js
 **/